import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { capitalize, find, isEmpty, isNil, map } from 'lodash';
import { Button, CircularProgress, DialogActions, DialogContent, MenuItem } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { getPartnerPractices } from 'store/thunks/partnerThunks';
import SelectField from 'common/forms/SelectField';
import { getPartnerCatalogApi } from 'api/partner';
import { casingFormat } from 'common/utils';

const ModifyAssociationsForm = ({ handleClose, loading }) => {
  const form = useForm();
  const formState = useFormState();
  const dispatch = useDispatch();
  const { partner: partnerState, auth: authState } = useSelector((state) => ({
    partner: state.partner,
    auth: state.auth,
  }));
  const currentTenantPartners = partnerState[authState?.currentTenantId];
  const selectedPartner = find(currentTenantPartners, {
    partnerUuid: formState.values.partnerId,
  });
  const practices = selectedPartner?.partnerPractices;
  const [selectedPractice, setPractice] = useState(null);

  useEffect(() => {
    if (formState.values.partnerId) {
      setPractice(null);
      dispatch(getPartnerPractices({ partnerIds: [formState.values.partnerId] }));
      getPartnerCatalogApi({ partnerId: formState.values.partnerId }).then((partnerFormulary) =>
        form.change('partnerFormulary', partnerFormulary)
      );
    }
  }, [dispatch, form, formState.values.partnerId]);

  const onChangePractice = (event) => {
    const selectedPracticeId = event.target.value;
    setPractice(selectedPracticeId);
  };

  return (
    <>
      <DialogContent>
        <SelectField
          id='partnerId'
          name='partnerId'
          label='Partner'
          required
          fullWidth
          endAdornment={
            isNil(currentTenantPartners) ? <CircularProgress sx={{ mr: 3 }} size={20} /> : undefined
          }
        >
          {currentTenantPartners?.map((partner) => (
            <MenuItem key={partner?.partnerUuid} value={partner?.partnerUuid}>
              {casingFormat(partner?.partnerName)}
            </MenuItem>
          ))}
        </SelectField>

        <SelectField
          id='NewOrder-SourceForm-practiceId-dropdown'
          name='practiceId'
          label='Practice'
          required
          disabled={!formState.values.partnerId || isNil(practices)}
          endAdornment={
            formState.values.partnerId && isNil(practices) ? (
              <CircularProgress sx={{ mr: 3 }} size={20} />
            ) : undefined
          }
          onChange={onChangePractice}
        >
          {map(practices, (practice) => (
            <MenuItem key={practice?.practiceId} value={practice?.practiceId}>
              {casingFormat(practice?.practiceName)}
            </MenuItem>
          ))}
          {!practices?.length && <MenuItem disabled>No Practice found</MenuItem>}
        </SelectField>
        <SelectField
          id='NewOrder-SourceForm-partnerAccountId-dropdown'
          name='partnerAccountId'
          label='Partner Account'
          disabled={!formState.values.practiceId}
        >
          {map(
            find(currentTenantPartners, { partnerUuid: formState.values.partnerId })
              ?.partnerAccount,
            (partnerAccount) => (
              <MenuItem
                key={partnerAccount?.partnerAccountId}
                value={partnerAccount?.partnerAccountId}
              >
                {capitalize(partnerAccount?.partnerAccountName)}
              </MenuItem>
            )
          )}
          {isEmpty(
            find(currentTenantPartners, { partnerUuid: formState.values.partnerId })?.partnerAccount
          ) && <MenuItem disabled>No accounts found</MenuItem>}
        </SelectField>
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' color='secondary' onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          loading={loading}
          type='submit'
          loadingIndicator={<CircularProgress size={20} color='inherit' />}
          variant='contained'
          color='primary'
          disabled={isEmpty(practices) || !selectedPractice}
        >
          Update
        </LoadingButton>
      </DialogActions>
    </>
  );
};

ModifyAssociationsForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
export default ModifyAssociationsForm;
